'use client'

import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setCountryList } from 'store/features/projectSlice'

export default function InitReduxFromServer({ countryList }) {
  const dispatch = useDispatch()

  useEffect(() => {
    if (countryList) {
      let CountryList = countryList.filter(
        (country) => country.phonecode !== '92'
      )
      dispatch(setCountryList(CountryList))
    }
  }, [countryList, dispatch])

  return null
}
